import { api } from "./client.js";
import type { Rule, RulesListResponse } from "@cas/shared";

export const rulesApi = {
  list:    () => api.get<RulesListResponse>("manage/rules").then(r => r.rules),
  create:  (rule: Partial<Rule>) => api.post<{ rule: Rule }>("manage/rules", { rule }).then(r => r.rule),
  update:  (id: string, rule: Rule) => api.put<{ rule: Rule }>(`manage/rules/${id}`, { rule }).then(r => r.rule),
  remove:  (id: string) => api.del<void>(`manage/rules/${id}`),
};
